import { ReactNode, FunctionComponent } from 'react';

import { Header } from '../Header';
import { StepIndicator, StepIndicatorColors } from '../StepIndicator';

import styles from './main.scss';

type StepHeaderProps = {
    dataTn?: string;
    title: ReactNode;
    subtitle?: ReactNode;
    htmlElementType?: 'div' | 'h1' | 'h2';
    totalSteps?: number;
    currentStep?: number;
    activeStepColor?: StepIndicatorColors;
};

export const StepHeader: FunctionComponent<StepHeaderProps> = props => {
    const {
        title,
        subtitle,
        dataTn,
        htmlElementType = 'div',
        totalSteps = 0,
        currentStep = 0,
        activeStepColor,
    } = props;
    return (
        <div className={styles.wrapper} data-tn={`step-header${dataTn ? `-${dataTn}` : ''}`}>
            <Header
                title={title}
                subtitle={subtitle}
                htmlElementType={htmlElementType}
                dataTn={dataTn}
            />
            <StepIndicator
                hasHeader
                totalSteps={totalSteps}
                currentStep={currentStep}
                activeStepColor={activeStepColor}
                dataTn={dataTn}
            />
        </div>
    );
};
